/**
 * Migration 001 — Initial schema.
 * Creates all tables for Phase 1 + Phase 2.
 * Phase 1 active: collection_log, source_events (optional).
 * Phase 2 active: all tables.
 */

export const MIGRATION_VERSION = 1;

export const MIGRATION_001_UP = `
CREATE TABLE IF NOT EXISTS entities (
  id TEXT PRIMARY KEY,
  type TEXT NOT NULL,
  name TEXT NOT NULL,
  aliases TEXT,
  description TEXT,
  attributes TEXT,
  first_seen TEXT NOT NULL,
  last_seen TEXT NOT NULL,
  confidence REAL,
  tags TEXT,
  notes TEXT,
  watch_status TEXT DEFAULT 'none',
  created_at TEXT NOT NULL,
  updated_at TEXT NOT NULL
);

CREATE TABLE IF NOT EXISTS relationships (
  id TEXT PRIMARY KEY,
  source_entity_id TEXT NOT NULL,
  target_entity_id TEXT NOT NULL,
  type TEXT NOT NULL,
  confidence REAL,
  evidence TEXT,
  first_seen TEXT NOT NULL,
  last_seen TEXT NOT NULL,
  FOREIGN KEY (source_entity_id) REFERENCES entities(id),
  FOREIGN KEY (target_entity_id) REFERENCES entities(id)
);

CREATE TABLE IF NOT EXISTS alert_rules (
  id TEXT PRIMARY KEY,
  name TEXT NOT NULL,
  description TEXT,
  type TEXT NOT NULL,
  conditions TEXT NOT NULL,
  actions TEXT NOT NULL,
  enabled INTEGER DEFAULT 1,
  created_at TEXT NOT NULL,
  last_triggered TEXT,
  trigger_count INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS alert_history (
  id TEXT PRIMARY KEY,
  rule_id TEXT NOT NULL,
  timestamp TEXT NOT NULL,
  event_data TEXT NOT NULL,
  severity TEXT NOT NULL,
  acknowledged INTEGER DEFAULT 0,
  acknowledged_at TEXT,
  notes TEXT,
  FOREIGN KEY (rule_id) REFERENCES alert_rules(id)
);

CREATE TABLE IF NOT EXISTS collection_log (
  id TEXT PRIMARY KEY,
  source_id TEXT NOT NULL,
  timestamp TEXT NOT NULL,
  event_count INTEGER,
  status TEXT NOT NULL,
  error TEXT,
  duration_ms INTEGER
);

CREATE TABLE IF NOT EXISTS workspaces (
  id TEXT PRIMARY KEY,
  name TEXT NOT NULL,
  description TEXT,
  state TEXT NOT NULL,
  created_at TEXT NOT NULL,
  updated_at TEXT NOT NULL,
  is_active INTEGER DEFAULT 0
);

CREATE TABLE IF NOT EXISTS geofences (
  id TEXT PRIMARY KEY,
  name TEXT NOT NULL,
  polygon TEXT NOT NULL,
  type TEXT NOT NULL,
  linked_rule_id TEXT,
  FOREIGN KEY (linked_rule_id) REFERENCES alert_rules(id)
);

CREATE TABLE IF NOT EXISTS source_events (
  id TEXT PRIMARY KEY,
  source_id TEXT NOT NULL,
  timestamp TEXT NOT NULL,
  type TEXT NOT NULL,
  title TEXT NOT NULL,
  description TEXT,
  location_lat REAL,
  location_lng REAL,
  location_name TEXT,
  country_code TEXT,
  severity TEXT,
  confidence REAL,
  tags TEXT,
  raw_data TEXT,
  created_at TEXT NOT NULL
);

-- source_events indexes (high-volume, queried by time range, source, type, country)
CREATE INDEX IF NOT EXISTS idx_source_events_timestamp ON source_events(timestamp);
CREATE INDEX IF NOT EXISTS idx_source_events_source_id ON source_events(source_id);
CREATE INDEX IF NOT EXISTS idx_source_events_type ON source_events(type);
CREATE INDEX IF NOT EXISTS idx_source_events_country_code ON source_events(country_code);
CREATE INDEX IF NOT EXISTS idx_source_events_source_timestamp ON source_events(source_id, timestamp);

-- entities indexes (queried by type, watch status, recency)
CREATE INDEX IF NOT EXISTS idx_entities_type ON entities(type);
CREATE INDEX IF NOT EXISTS idx_entities_watch_status ON entities(watch_status);
CREATE INDEX IF NOT EXISTS idx_entities_last_seen ON entities(last_seen);

-- relationships indexes (graph traversal by entity ID)
CREATE INDEX IF NOT EXISTS idx_relationships_source_entity ON relationships(source_entity_id);
CREATE INDEX IF NOT EXISTS idx_relationships_target_entity ON relationships(target_entity_id);

-- alert_history indexes (queried by rule, time, severity)
CREATE INDEX IF NOT EXISTS idx_alert_history_rule_id ON alert_history(rule_id);
CREATE INDEX IF NOT EXISTS idx_alert_history_timestamp ON alert_history(timestamp);
CREATE INDEX IF NOT EXISTS idx_alert_history_severity ON alert_history(severity);

-- collection_log indexes (queried by source and time)
CREATE INDEX IF NOT EXISTS idx_collection_log_source_id ON collection_log(source_id);
CREATE INDEX IF NOT EXISTS idx_collection_log_timestamp ON collection_log(timestamp);
`;

export const MIGRATION_001_DOWN = `
-- Drop indexes first
DROP INDEX IF EXISTS idx_source_events_timestamp;
DROP INDEX IF EXISTS idx_source_events_source_id;
DROP INDEX IF EXISTS idx_source_events_type;
DROP INDEX IF EXISTS idx_source_events_country_code;
DROP INDEX IF EXISTS idx_source_events_source_timestamp;
DROP INDEX IF EXISTS idx_entities_type;
DROP INDEX IF EXISTS idx_entities_watch_status;
DROP INDEX IF EXISTS idx_entities_last_seen;
DROP INDEX IF EXISTS idx_relationships_source_entity;
DROP INDEX IF EXISTS idx_relationships_target_entity;
DROP INDEX IF EXISTS idx_alert_history_rule_id;
DROP INDEX IF EXISTS idx_alert_history_timestamp;
DROP INDEX IF EXISTS idx_alert_history_severity;
DROP INDEX IF EXISTS idx_collection_log_source_id;
DROP INDEX IF EXISTS idx_collection_log_timestamp;

-- Drop tables
DROP TABLE IF EXISTS source_events;
DROP TABLE IF EXISTS geofences;
DROP TABLE IF EXISTS workspaces;
DROP TABLE IF EXISTS collection_log;
DROP TABLE IF EXISTS alert_history;
DROP TABLE IF EXISTS alert_rules;
DROP TABLE IF EXISTS relationships;
DROP TABLE IF EXISTS entities;
`;
